'use client';

import { useSyncExternalStore } from 'react';

import { userStore } from '@/sdk/userStore';

export function useUserInfo(): Foxkit.UserCookie {
  const user = useSyncExternalStore(userStore.subscribe, userStore.get, userStore.get);

  return user;
}
